'use strict'

const getTextColorForBackground = (tagColor) => {
  if (!tagColor) {
    return '#000'
  }

  // Assume it's hex, so we have convert it
  const rgb = (typeof tagColor === 'string') ? hexToRgb(tagColor) : tagColor
  const brightness = getRgbBrightness(rgb)

  return (brightness < 155) ? '#fff' : '#000'
}

const getRgbBrightness = (rgb) => {
  return (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b)
}

const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : null
}

export { hexToRgb, getTextColorForBackground, getRgbBrightness }
